import { BotId } from '@feedyou/schema'
import { transformAHrefUrlsInHtml } from './transformAHrefUrlsInHtml'

import { stripQueryStringFromUrl } from '@feedyou/utils'
import { getAccessToken } from '../../../../../lib/getAccessToken'
import { getApiUrl } from '../../../../../apiService'

export const fixLinksInCallsTable = (tableHtml: string, botId: BotId, isFullscreen: boolean) => {
  return transformAHrefUrlsInHtml(
    tableHtml, // I <3 PRETTIER
    (url: string) => getReplacementForLink(url, botId, isFullscreen)
  )
}

function getReplacementForLink(url: string, botId: string, isFullscreen: boolean): string {
  const urlPathWithoutQueryParams = stripQueryStringFromUrl(url)
  const urlPathLogsOrRecBeforeUserId = '/api/management/telephony/calls/'
  const urlPathTranscriptBeforeUserId = '/api/management/transcript/users/'
  const urlPathStepValidatorBeforeStepId = '/api/management/transcript/validator/step/'
  const urlPathValidatorPrefix = '/api/management/transcript/validator/type/'

  if (urlPathWithoutQueryParams.startsWith(urlPathTranscriptBeforeUserId)) {
    const userId = urlPathWithoutQueryParams.replace(urlPathTranscriptBeforeUserId, '')
    return getCallsTranscriptUrl(botId, userId) + (isFullscreen ? '?fullscreen' : '')
  }

  if (urlPathWithoutQueryParams.startsWith(urlPathValidatorPrefix)) {
    const validatorType = urlPathWithoutQueryParams.replace(urlPathValidatorPrefix, '')
    return getValidatorTypeTranscriptUrl(botId, validatorType) + (isFullscreen ? '?fullscreen' : '')
  }

  if (urlPathWithoutQueryParams.startsWith(urlPathLogsOrRecBeforeUserId)) {
    const secondHalfOfUrlPath = urlPathWithoutQueryParams.replace(urlPathLogsOrRecBeforeUserId, '')
    return getReplacementUrlPathForLogsOrRecFile(botId, secondHalfOfUrlPath, isFullscreen)
  }

  if (urlPathWithoutQueryParams.startsWith(urlPathStepValidatorBeforeStepId)) {
    const stepId = urlPathWithoutQueryParams.replace(urlPathStepValidatorBeforeStepId, '')
    return getValidatorStepTranscriptUrl(botId, stepId) + (isFullscreen ? '?fullscreen' : '')
  }

  return url
}

function getReplacementUrlPathForLogsOrRecFile(
  botId: string,
  secondHalfOfUrlPath: string,
  isFullscreen: boolean
): string {
  if (secondHalfOfUrlPath.endsWith('/logs')) {
    return `${getCallsUrl(botId)}/user/${secondHalfOfUrlPath}${isFullscreen ? '?fullscreen' : ''}`
  }

  if (secondHalfOfUrlPath.endsWith('/rec-file')) {
    const accessToken = getAccessToken()
    const callId = secondHalfOfUrlPath.replace('/rec-file', '')
    const hostingApiUrl = getApiUrl() + `/bots/${botId}/telephony/calls/${callId}/recFile`

    // put nice designer URL to href so it could be copied, but redirect directly to file after click to avoid window open
    return `${getCallsUrl(
      botId
    )}/user/${secondHalfOfUrlPath}" onclick="window.location.href = '${hostingApiUrl}?token=${accessToken}'; return false;`
  }

  if (secondHalfOfUrlPath.includes('/part-rec-file')) {
    const accessToken = getAccessToken()
    const [callId, partUid] = secondHalfOfUrlPath.replace('/part-rec-file', '').split('/')
    const hostingApiUrl =
      getApiUrl() + `/bots/${botId}/telephony/calls/${callId}/partRecFile/${partUid}`

    return `${hostingApiUrl}?token=${accessToken}`
  }

  return ''
}

function getCallsUrl(botId: string): string {
  return `/bots/${botId}/calls`
}

function getCallsTranscriptUrl(botId: string, userId: string): string {
  return `/bots/${botId}/calls/user/${userId}/transcript`
}

function getValidatorTypeTranscriptUrl(botId: string, validatorType: string): string {
  return `/bots/${botId}/calls/validator/type/${validatorType}`
}

function getValidatorStepTranscriptUrl(botId: string, stepId: string): string {
  return `/bots/${botId}/calls/validator/step/${stepId}`
}
